
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import {Loadmore,Spinner } from "mint-ui";
import Countdown from 'vux/src/components/countdown/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
data(){
return {
personInfoId:'',
list: [],
allLoaded: false,
bottomStatus: '',
wrapperHeight: 0,
loadmoreShow:true,
loadmoreTxt:'加载中····',
bottomCount: 20,
pageSize:10,
pageNumber:1,
total:0,
resultOption:[],
}
},


methods: {
handleBottomChange(status) {
this.bottomStatus = status;
if(status =='loading'){
this.loadmoreTxt = '加载中';
}
},
loadBottom() {

setTimeout(() => {
this.pageNumber++;
this.seachSumbit();
}, 1500);
},

seachSumbit(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
/**let pamras = {
personInfoId: personInfoId,
pageNumber: this.pageNumber,
pageSize: this.pageSize,
}*/
this.personInfoId=this.$route.query.personInfoId;
fetch('post',urlConfig.patientLabInfosGet+"?personInfoId="+this.personInfoId+"&pageNumber="+this.pageNumber+"&pageSize="+this.pageSize).then(response => {
this.total=response.total;







let labRows=response.rows;

labRows.forEach(element => {
try{
if(element.highLow!=null&&element.highLow!=""){

let highlow=String(element.highLow);

highlow=highlow.replace(/H/g, "↑")
highlow=highlow.replace("L", "↓")

element.highLow=highlow
}
}
catch(error){
alert(error)
}

this.resultOption.push(element);
});

if(this.resultOption.length == 0){
this.loadmoreShow = false;
this.loadmoreTxt = '暂无数据';
this.allLoaded = true;
}else if(this.resultOption.length === this.total){
this.loadmoreShow = false;
this.loadmoreTxt = '已经到底了';
this.allLoaded = true;
}else{
this.loadmoreShow = false;
this.loadmoreTxt = '上拉加载更多';
this.allLoaded = false;
}

/**this.resultOption.forEach(element=>{

})*/

this.$refs.loadmore.onBottomLoaded();

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})

},//搜索


getData(){

this.seachSumbit()


/**fetch('post',urlConfig.patientLabInfosGet+"?personInfoId="+this.personInfoId).then(response => {
console.log("response3="+JSON.stringify(response))

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})*/
}
},
components: {
"mt-loadmore": Loadmore,Countdown,Toast,XDialog,XInput,Cell, Group, XHeader,XButton,Checker, CheckerItem,Icon,CellBox,LoadMore,XTable
},
mounted(){

getken(this.getData);










}
}



// WEBPACK FOOTER //
// ./src/project/prescnoVerifyProject/patientlabinfo.vue